import { axios } from '@/main';

export default class AnalysisResource {
    async getFunnelReport (page, startDate, endDate, websiteId) {
        return await axios.get(
            process.env.VUE_APP_REST_API + `reports/funnel?page=${page}&date_start=${startDate}&date_end=${endDate}&website_id=${websiteId}`
        )

    }

    async getFunnelReportItem (transactionId) {
        return await axios.get(
            process.env.VUE_APP_REST_API + `reports/funnel/${transactionId}`
        )

    }

    async exportFunnelReport (format, startDate, endDate, websiteId) {
        return await axios.get(
            process.env.VUE_APP_REST_API + `reports/funnel/export/${format}?date_start=${startDate}&date_end=${endDate}&website_id=${websiteId}`,
            {
                responseType: 'arraybuffer'
            }
        )
    }

    async requestPageReport (startDate, endDate, websiteId) {
        return await axios.post(
            process.env.VUE_APP_REST_API + `reports/page/request`, {
                'date_start': startDate,
                'date_end': endDate,
                'website_id': websiteId,
            }
        )
    }

    async listPageReports () {
        return await axios.get(
            process.env.VUE_APP_REST_API + `reports/page/list`
        )
    }

    async getPageReport (id) {
        return await axios.get(
            process.env.VUE_APP_REST_API + `reports/page/${id}`
        )
    }
}
